var Actions;
(function (Actions) {
    Actions["GET_MASTER_ASSESSOR_LIST"] = "getAllMasterAssessorList";
    Actions["DELETE_LIST"] = "handleMasterAssessorDeleteList";
    Actions["HANDLE_SORT_CHANGE"] = "handleMasterAssessorListSortChange";
    Actions["HANDLE_CURRENT_PAGE_CHANGE"] = "handleMasterSchemaListPageChange";
    Actions["HANDLE_CURRENT_PAGE_CHANGE_ON_SORT"] = "handleMasterSchemaListPageChangeOnSort";
    Actions["EXPORT_MASTER_ASSESSOR"] = "handleExportMasterAssessor";
    Actions["DOWNLOAD_MASTER_ASSESSOR"] = "handleDownloadMasterAssessor";
    // post data
    Actions["POST_DATA"] = "postMasterAssessorData";
    Actions["UPDATE_DATA"] = "updateMasterAssessorData";
    Actions["GET_NIK_DETAIL_OPTIONS"] = "getMasterAssessorNikDetailOptions";
    Actions["GET_SCHEMA_OPTIONS"] = "getMasterAssessorSchemaOptions";
    Actions["GET_SITE_OPTIONS"] = "getMasterAssessorSiteOptions";
    Actions["UPLOAD_FILE"] = "handleMasterAssessorUploadFile";
    Actions["EXPORT_ASSESSOR"] = "handleExportAssessor";
    Actions["DOWNLOAD_ASSESSOR"] = "handleDownloadAssessor";
    Actions["UPLOAD_CHANGE_ASSESSOR"] = "handleUploadChangeAssessor";
    Actions["UPLOAD_CREATE_ASSESSOR"] = "handleUploadCreateAssessor";
    Actions["UPLOAD_SUBMIT_CHANGE_ASSESSOR"] = "handleSubmitChangeAssessor";
    Actions["UPLOAD_SUBMIT_CREATE_ASSESSOR"] = "handleSubmitCreateAssessor";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_ORDER"] = "setMasterAssessorOrderBy";
    Mutations["SET_MASTER_ASSESSOR_LIST"] = "setMasterAssessorList";
    Mutations["SET_LOADING"] = "setMasterSchemaLoading";
    Mutations["SET_PAGINATION_TOTAL_PAGE"] = "setMasterAssessorListPaginationTotalPage";
    Mutations["SET_PAGINATION_LOADING"] = "setMasterSchemaListPaginationLoading";
    Mutations["SET_PAGINATION_CURRENT_PAGE_CHANGE"] = "setMasterSchemaListCurrentPageChange";
    Mutations["SET_FILTER"] = "setMasterAssessorFilterParams";
    Mutations["CLEAR_FILTER"] = "handleClearMasterAssessorFilterParams";
    Mutations["ADD_ATTACHMENT"] = "setMasterAssessorSchemeAttachment";
    Mutations["SET_MODAL_LOADING"] = "setMasterAssessorModalLoading";
    Mutations["SET_SCHEMA_OPTIONS_LOADING"] = "setMasterAssessorSchemaOptionsLoading";
    Mutations["SET_SITE_OPTIONS_LOADING"] = "setMasterAssessorSiteOptionsLoading";
    Mutations["SET_NIK_SEARCH_LOADING"] = "setMasterAssessorNIKSearchLoading";
    Mutations["SET_UPLOAD_LOADING"] = "setMasterAssessorPostUploadLoading";
    Mutations["SET_EDIT_LIST"] = "setMasterAssessorEditList";
    Mutations["SET_NIK_OPTIONS"] = "setMasterAssessorNikDetailOptions";
    Mutations["SET_SCHEMA_OPTIONS"] = "setMasterAssessorSchemaOptions";
    Mutations["SET_SITE_OPTIONS"] = "setMasterAssessorSiteOptions";
    Mutations["SET_NIK_DETAIL"] = "setMasterAssessorNikDetail";
    // clear form input
    Mutations["CLEAR_FORM_INPUT"] = "clearMasterAssessorFormInput";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
